import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Badge({ variant, className, children, ...rest }) {
    return (_jsx("span", { className: cn("fwfa-badge", variant && `fwfa-badge--${variant}`, className), ...rest, children: children }));
}
//# sourceMappingURL=Badge.js.map